module.exports = __webpack_public_path__ + "img/digital_grid_mob.318d1304.svg";